// ==================== INDUSTRY FRAMEWORKS ====================

export const INDUSTRY_FRAMEWORKS = {
  healthcare: {
    frameworkName: 'Healthcare AI Maturity Framework (HAMF)',
    version: '3.0',
    description: 'Comprehensive framework for AI adoption in healthcare',
    keyDimensions: [
      {
        dimension: 'Clinical Excellence',
        weight: 0.30,
        subDimensions: ['Diagnostic Accuracy', 'Treatment Personalization', 'Patient Outcomes']
      },
      {
        dimension: 'Operational Efficiency',
        weight: 0.25,
        subDimensions: ['Resource Utilization', 'Workflow Optimization', 'Cost Management']
      },
      {
        dimension: 'Patient Experience',
        weight: 0.25,
        subDimensions: ['Access to Care', 'Engagement', 'Satisfaction']
      },
      {
        dimension: 'Research & Innovation',
        weight: 0.20,
        subDimensions: ['Clinical Trials', 'Drug Discovery', 'Evidence Generation']
      }
    ],
    regulatoryRequirements: [
      { regulation: 'HIPAA', scope: 'Patient data privacy', impact: 'Critical' },
      { regulation: 'FDA', scope: 'Medical device approval', impact: 'Critical' },
      { regulation: 'HITECH', scope: 'Health IT standards', impact: 'High' }
    ],
    useCaseCatalog: [
      { useCase: 'AI-powered Diagnostics', value: 'High', complexity: 'High', timeline: '6-12 months' },
      { useCase: 'Predictive Patient Monitoring', value: 'High', complexity: 'Medium', timeline: '3-6 months' },
      { useCase: 'Automated Administrative Tasks', value: 'Medium', complexity: 'Low', timeline: '1-3 months' }
    ]
  },
  
  finance: {
    frameworkName: 'Financial Services AI Framework (FSAIF)',
    version: '4.0',
    description: 'AI adoption framework for financial institutions',
    keyDimensions: [
      {
        dimension: 'Risk Management',
        weight: 0.30,
        subDimensions: ['Credit Risk', 'Market Risk', 'Operational Risk']
      },
      {
        dimension: 'Customer Intelligence',
        weight: 0.25,
        subDimensions: ['Customer 360', 'Personalization', 'Lifecycle Management']
      },
      {
        dimension: 'Operational Excellence',
        weight: 0.25,
        subDimensions: ['Process Automation', 'Cost Optimization', 'Service Quality']
      },
      {
        dimension: 'Regulatory Compliance',
        weight: 0.20,
        subDimensions: ['AML', 'KYC', 'Reporting']
      }
    ],
    regulatoryRequirements: [
      { regulation: 'Basel III', scope: 'Capital requirements', impact: 'Critical' },
      { regulation: 'Dodd-Frank', scope: 'Financial stability', impact: 'Critical' },
      { regulation: 'MiFID II', scope: 'Market transparency', impact: 'High' }
    ],
    useCaseCatalog: [
      { useCase: 'Real-time Fraud Detection', value: 'Critical', complexity: 'High', timeline: '3-6 months' },
      { useCase: 'Credit Scoring', value: 'High', complexity: 'Medium', timeline: '2-4 months' },
      { useCase: 'Algorithmic Trading', value: 'High', complexity: 'Very High', timeline: '6-12 months' }
    ]
  },
  
  ecommerce: {
    frameworkName: 'Retail AI Transformation Framework (RAITF)',
    version: '2.0',
    description: 'AI framework for retail and e-commerce',
    keyDimensions: [
      {
        dimension: 'Customer Experience',
        weight: 0.30,
        subDimensions: ['Personalization', 'Recommendation', 'Engagement']
      },
      {
        dimension: 'Supply Chain',
        weight: 0.25,
        subDimensions: ['Demand Forecasting', 'Inventory', 'Logistics']
      },
      {
        dimension: 'Merchandising',
        weight: 0.25,
        subDimensions: ['Pricing', 'Assortment', 'Promotions']
      },
      {
        dimension: 'Operations',
        weight: 0.20,
        subDimensions: ['Order Management', 'Returns', 'Customer Service']
      }
    ],
    regulatoryRequirements: [
      { regulation: 'GDPR', scope: 'Data privacy', impact: 'Critical' },
      { regulation: 'CCPA', scope: 'Consumer privacy', impact: 'High' },
      { regulation: 'PCI-DSS', scope: 'Payment security', impact: 'Critical' }
    ],
    useCaseCatalog: [
      { useCase: 'Personalized Recommendations', value: 'High', complexity: 'Medium', timeline: '2-3 months' },
      { useCase: 'Dynamic Pricing', value: 'High', complexity: 'Medium', timeline: '2-4 months' },
      { useCase: 'Demand Forecasting', value: 'High', complexity: 'Medium', timeline: '3-6 months' }
    ]
  },
  
  manufacturing: {
    frameworkName: 'Industry 4.0 AI Framework',
    version: '5.0',
    description: 'AI framework for smart manufacturing',
    keyDimensions: [
      {
        dimension: 'Production Optimization',
        weight: 0.30,
        subDimensions: ['Scheduling', 'Quality', 'Yield']
      },
      {
        dimension: 'Asset Management',
        weight: 0.25,
        subDimensions: ['Predictive Maintenance', 'Lifecycle', 'Reliability']
      },
      {
        dimension: 'Supply Chain',
        weight: 0.25,
        subDimensions: ['Visibility', 'Planning', 'Collaboration']
      },
      {
        dimension: 'Sustainability',
        weight: 0.20,
        subDimensions: ['Energy Efficiency', 'Waste Reduction', 'Environmental']
      }
    ],
    regulatoryRequirements: [
      { regulation: 'ISO 9001', scope: 'Quality management', impact: 'High' },
      { regulation: 'OSHA', scope: 'Workplace safety', impact: 'Critical' },
      { regulation: 'EPA', scope: 'Environmental', impact: 'High' }
    ],
    useCaseCatalog: [
      { useCase: 'Predictive Maintenance', value: 'High', complexity: 'Medium', timeline: '3-6 months' },
      { useCase: 'Quality Inspection', value: 'High', complexity: 'Medium', timeline: '2-4 months' },
      { useCase: 'Energy Optimization', value: 'Medium', complexity: 'Low', timeline: '1-3 months' }
    ]
  }
};